(() => {
  const headingGroups = [
    {
      gridSelector: '[data-lineup-list-grid]',
      titleSelector: '.lineup-card__title',
      cardSelector: '.lineup-card',
    },
    {
      gridSelector: '[data-collection-showcase-products]',
      titleSelector: '.collection-showcase__product-heading > h3',
      cardSelector: '.collection-showcase__product',
    },
  ];

  const syncTitleHeights = (grid, group) => {
    const titles = [...grid.querySelectorAll(group.titleSelector)];

    titles.forEach((title) => {
      title.style.minHeight = '';
    });

    const titlesByRow = new Map();
    titles.forEach((title) => {
      const card = title.closest(group.cardSelector);
      const row = Math.round(card.getBoundingClientRect().top);
      const rowTitles = titlesByRow.get(row) || [];

      rowTitles.push(title);
      titlesByRow.set(row, rowTitles);
    });

    titlesByRow.forEach((rowTitles) => {
      const tallestTitle = Math.max(...rowTitles.map((title) => title.getBoundingClientRect().height));

      rowTitles.forEach((title) => {
        title.style.minHeight = `${tallestTitle}px`;
      });
    });
  };

  const initialiseGrid = (grid, group) => {
    if (grid.dataset.lineupTitleHeightsReady) return;
    grid.dataset.lineupTitleHeightsReady = 'true';

    let animationFrame;
    const scheduleSync = () => {
      cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(() => syncTitleHeights(grid, group));
    };

    const observer = new ResizeObserver(scheduleSync);
    grid.querySelectorAll('.lineup-card__title').forEach((title) => observer.observe(title));
    observer.observe(grid);

    scheduleSync();
  };

  const initialise = (scope = document) => {
    headingGroups.forEach((group) => {
      scope.querySelectorAll(group.gridSelector).forEach((grid) => initialiseGrid(grid, group));
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  document.addEventListener('related-product:loaded', (event) => initialise(event.target));
})();
